import { getKycByExternalId, OnboardingFulfilledBy } from '@nemuru-eng/js-api-client';

import { ApplicationParticipant } from '@/config/types';
import { useCache } from '@/hooks/requests/useCache';
import { useSetPageLoadingWhenRequesting } from '@/hooks/requests/useSetPageLoadingWhenRequesting';

interface UseBorrowerKycProps {
  externalId: string;
  onboardingDetails: ApplicationParticipant['onboardingDetails'];
}

export const useBorrowerKYC = ({ externalId, onboardingDetails }: UseBorrowerKycProps) => {
  const { data: kyc, loading: loadingGetKycByExternalId } = useCache(getKycByExternalId, { loanId: externalId });

  useSetPageLoadingWhenRequesting('BORROWER_KYC', [loadingGetKycByExternalId]);

  const areCurrentOnboardingDetailsOfTypeBorrowerOnline =
    onboardingDetails?.fulfilledBy === OnboardingFulfilledBy.BORROWER_ONLINE &&
    onboardingDetails &&
    'documentId' in onboardingDetails;

  const areCurrentOnboardingDetailsOfTypeBorrower = onboardingDetails && 'userDetails' in onboardingDetails;

  const documentNumber = areCurrentOnboardingDetailsOfTypeBorrower
    ? onboardingDetails?.userDetails?.documentId.documentNumber
    : areCurrentOnboardingDetailsOfTypeBorrowerOnline
    ? onboardingDetails?.documentId?.documentNumber
    : undefined;

  const filteredKyc =
    documentNumber !== undefined
      ? kyc
          ?.sort((a, b) => (b?.updatedAt?.getTime() ?? 0) - (a?.updatedAt?.getTime() ?? 0))
          .filter((kycItem) => kycItem.documentNumber.toUpperCase() === documentNumber?.toUpperCase())
      : undefined;

  return { filteredKyc };
};
